import {
  Directive,
  forwardRef,
  Input
} from '@angular/core';
import {
  AbstractControl,
  AsyncValidator,
  NG_ASYNC_VALIDATORS,
  ValidationErrors
} from '@angular/forms';

@Directive({
  selector : '[worUniquenessValidator]',
  providers: [
    {
      multi      : true,
      provide    : NG_ASYNC_VALIDATORS,
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      useExisting: forwardRef(() => UniquenessValidator)
    }
  ]
})
export class UniquenessValidator implements AsyncValidator {
  @Input() checkInitially = false;
  @Input() onValidate : ( value : string ) => Promise<boolean>;
  @Input('worUniquenessValidator') model: string;

  validate ( control: AbstractControl ): Promise<ValidationErrors | null> {
    if ( !this.checkInitially && control.value === this.model ) {
      return null;
    }

    return this.onValidate(control.value)
    .then(( isUnique : boolean ) => {
      return isUnique
        ? null
        : { unique: true };
    });
  }
}